<template>
  <div id="progreso">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid w-100"
      />
    </router-link>

    <section class="pantalla">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="pregunta abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/bg-pregunta-trapezoide.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div
                class="pregunta_txt abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="bold">
                  <span class="azulclaro">NIVEL 01 - </span>
                  <span class="electrico">ESTILO DE APRENDIZAJE</span>
                </div>
                <div class="blanco">
                  Conocer tu estilo de aprendizaje predominante te ayudará a
                  captar de mejor manera la información que recibes.
                </div>
              </div>
            </div>

            <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/quasar-verde.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="cont-btn-sig btn-avanzar ">
              <button @click="avanzar" class="btn-sig">
                <span class="texto">
                  <span class="bold">CONTINUAR</span>
                </span>
                <img
                  class="icono"
                  src="../../../assets/imgs/mision/cohete.png"
                  alt="icono"
                />
                <span class="flecha">
                  <img
                    src="../../../assets/imgs/mision/flecha-sig3.png"
                    alt="icono"
                  />
                </span>
              </button>
              <div class="flecha2">
                <img
                  src="../../../assets/imgs/mision/flecha-sig2.png"
                  alt="icono"
                />
              </div>
              <div class="flecha1">
                <img
                  src="../../../assets/imgs/mision/flecha-sig1.png"
                  alt="icono"
                />
              </div>
            </div>

            <div
              v-if="resultado != null"
              class="info abs"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div class="row">
                <div class="col-6">
                  <div class="tarjeta bggradazul turquesa">
                    <div class="grid fpG1 bold">
                      <div class="titulo pb5">PUNTAJES_</div>

                      <div
                        class="row pb5 d-flex justify-content-center align-items-center"
                      >
                        <div class="col-8 pb3">EXPERIENCIA CONCRETA</div>
                        <div class="col-4 pb3">
                          <span class="fpXXXG pr2">
                            {{ habilidades.habilidad_0 }}
                          </span>
                          PUNTOS
                        </div>
                        <div class="col-12">
                          <div
                            class="barra bgmoradoclaro"
                            :style="{ width: barras.habilidad_0 }"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="row pb5 d-flex justify-content-center align-items-center"
                      >
                        <div class="col-8 pb3">OBSERVACIÓN REFLEXIVA</div>
                        <div class="col-4 pb3">
                          <span class="fpXXXG pr2">
                            {{ habilidades.habilidad_1 }}
                          </span>
                          PUNTOS
                        </div>
                        <div class="col-12">
                          <div
                            class="barra bgrosa"
                            :style="{ width: barras.habilidad_1 }"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="row pb5 d-flex justify-content-center align-items-center"
                      >
                        <div class="col-8 pb3">CONCEPTUALIZACIÓN ABSTRACTA</div>
                        <div class="col-4 pb3">
                          <span class="fpXXXG pr2">
                            {{ habilidades.habilidad_2 }}
                          </span>
                          PUNTOS
                        </div>
                        <div class="col-12">
                          <div
                            class="barra bgazuloscuro"
                            :style="{ width: barras.habilidad_2 }"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="row pb5 d-flex justify-content-center align-items-center"
                      >
                        <div class="col-8 pb3">EXPERIMENTACIÓN ACTIVA</div>
                        <div class="col-4 pb3">
                          <span class="fpXXXG pr2">
                            {{ habilidades.habilidad_3 }}
                          </span>
                          PUNTOS
                        </div>
                        <div class="col-12">
                          <div
                            class="barra bgturquesa"
                            :style="{ width: barras.habilidad_3 }"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-12 pb5">
                      <div class="bggradazul tarjeta">
                        <div class="row">
                          <div class="col-12">
                            <div class="titulo pb5 bold fpG1 turquesa">
                              <span>RESULTADO_</span>
                            </div>
                            <div class="row pb5">
                              <div class="col-8">
                                <div class="azulclaro bold pb3">
                                  <div class="fpG2">
                                    {{ resultados[resultado].nombre_alterno }}
                                  </div>
                                  <div class="fpG">
                                    {{
                                      resultados[resultado].descripcion_nombre
                                    }}
                                  </div>
                                </div>
                                <div class="turquesa fpG bold">
                                  {{ resultados[resultado].nombre }}
                                </div>
                              </div>
                              <div class="col-4 text-center p-0">
                                <span
                                  class="btn-mas fpR bold"
                                  @click="toggleInfo"
                                >
                                  LEER MÁS
                                  <span class="flecha">
                                    <svg
                                      viewBox="0 0 1792 1792"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill="#ffffff"
                                        d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"
                                      />
                                    </svg>

                                    <span class="flecha">
                                      <svg
                                        height="1792"
                                        viewBox="0 0 1792 1792"
                                        width="1792"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill="#ffffff"
                                          d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"
                                        />
                                      </svg>
                                    </span>
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="bggradazul tarjeta">
                        <div class="row">
                          <div class="col-12">
                            <div class="titulo pb5 bold fpG1 turquesa">
                              <span>GADGET ADQUIRIDO_</span>
                            </div>
                            <div class="row pb5">
                              <div class="col-7">
                                <span class="azulclaro fpXG bold">{{
                                  resultados[resultado].gadget
                                }}</span>
                              </div>
                              <!-- <div class="col-5 text-center blanco gadget">
                                <img
                                  class="w-100"
                                  :src="
                                    require('../../../assets/imgs/mision/1/gadgets/maya-1-' +
                                      resultado +
                                      '.png')
                                  "
                                  :alt="resultado"
                                />
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="resultado_mision abs text-center" v-if="resultado != null" data-aos="zoom-in" data-aos-delay="600">
              <div>
                <span class="electrico fXG bold"> ¡Eres</span> <span class="electrico fXG bold">{{resultados[resultado].nombre}}</span> <span class="electrico fXG bold">!</span>
              </div>
            </div> -->

            <div
              class="personaje abs"
              data-aos="fade"
              data-aos-delay="800"
              v-if="settings.personaje != null"
            >
              <img
                :src="
                  require('../../../assets/imgs/avatar/' +
                    settings.personaje +
                    '.png')
                "
                alt="Encauce"
                class="img-fluid"
              />
              <img
                src="../../../assets/imgs/progreso/brillo-amarillo.png"
                alt="Encauce"
                class="img-fluid brillo"
              />

              <div class="gadget" :class="resultado">
                <img
                  class="w-100"
                  :src="
                    require('../../../assets/imgs/mision/1/gadgets/' + settings.personaje + '-' +
                      resultado +
                      '.png')
                  "
                  :alt="resultado"
                />
              </div>

              <!-- <div v-if="">

              </div> -->
            </div>

            <div class="overlayinfo bggradazulmorado" v-show="displayInfo">
              <div class="bgoverlay" @click="toggleInfo"></div>
              <div class="overlay container">
                <div class="closeoverlay" @click="toggleInfo">
                  <img
                    class="img-fluid"
                    src="../../../assets/imgs/mision/btn-cerrar-overlay.png"
                    alt="cerrar"
                  />
                </div>
                <div class="contenido row bggradmorado rounded pt5 px5 pb5">
                  <div class="col-12">
                    <div class="bold pb5">
                      <div class="fpXXG turquesa">
                        {{ resultados[resultado].nombre_alterno }}
                      </div>
                      <div class="fpG azulclaro">
                        {{ resultados[resultado].descripcion_nombre }}
                      </div>
                    </div>
                    <div
                      class="blanco fpG1"
                    >
                      <p class="bold">GENERALES</p>
                      <p>{{resultados[resultado].generales}}</p>
                    </div>
                    <div
                      class="blanco fpG1"
                    >
                      <p class="bold">{{resultados[resultado].caracteristicas}}</p>
                    </div>
                    <div
                      class="blanco fpG1"
                      v-html="resultados[resultado].descripcion"
                    ></div>
                    <!-- <div class="cont-btn-sig btn-avanzar col-12 pt5">
                      <button @click="avanzar" class="btn-sig">
                        <span class="texto">
                          <span class="bold">CONTINUAR</span>
                        </span>
                        <img
                          class="icono"
                          src="../../../assets/imgs/mision/cohete.png"
                          alt="icono"
                        />
                        <span class="flecha">
                          <img
                            src="../../../assets/imgs/mision/flecha-sig3.png"
                            alt="icono"
                          />
                        </span>
                      </button>
                      <div class="flecha2">
                        <img
                          src="../../../assets/imgs/mision/flecha-sig2.png"
                          alt="icono"
                        />
                      </div>
                      <div class="flecha1">
                        <img
                          src="../../../assets/imgs/mision/flecha-sig1.png"
                          alt="icono"
                        />
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../../../router/index";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      maya_outfit: -1,
      condicion: false,
      settings: {
        personaje: null,
        mision: 1,
      },
      mision: 1,
      avance: [],
      resultado: null,
      habilidades: {},
      displayInfo: false,
      barras: {
        habilidad_0: "0%",
        habilidad_1: "0%",
        habilidad_2: "0%",
        habilidad_3: "0%",
      },
      resultados: {},
      initiated: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    

    
    this.init();

    
  },
  methods: {
    init(){
      if (this.userProfile == undefined || this.initiated == true) {
        return;
      }

      this.initiated = true;


      this.resultados = this.$store.state.estilo_de_aprendizaje;

      console.log({instID: this.institucionID})

      AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
      
      this.getAvance();


    },
    async getAvance() {
      let vm = this;
      this.avance = await this.$store.dispatch("getAvance");
      console.log({ avance: this.avance });
      console.log({ mision: this.mision - 1 });
      console.log(this.avance.misiones[this.mision - 1].resultado_evaluacion);
      this.resultado = this.avance.misiones[
        this.mision - 1
      ].resultado_evaluacion;


      this.habilidades = this.avance.misiones[this.mision - 1].habilidades;


      this.avatar = this.avance.avatar;
      if (this.avatar != null) {
        this.settings.personaje =
          this.avatar.slug_personaje + "-" + this.avatar.id_outfit;
      }

      setTimeout(function () {
        vm.calculaBarras();
      }, 1500);
    },
    calculaBarras() {
      let multiplicador = 200;
      let total =
        this.habilidades.habilidad_0 +
        this.habilidades.habilidad_1 +
        this.habilidades.habilidad_2 +
        this.habilidades.habilidad_3;

      this.barras.habilidad_0 =
        (this.habilidades.habilidad_0 / total) * multiplicador;
      this.barras.habilidad_1 =
        (this.habilidades.habilidad_1 / total) * multiplicador;
      this.barras.habilidad_2 =
        (this.habilidades.habilidad_2 / total) * multiplicador;
      this.barras.habilidad_3 =
        (this.habilidades.habilidad_3 / total) * multiplicador;

      this.barras.habilidad_0 = this.barras.habilidad_0 + "%";
      this.barras.habilidad_1 = this.barras.habilidad_1 + "%";
      this.barras.habilidad_2 = this.barras.habilidad_2 + "%";
      this.barras.habilidad_3 = this.barras.habilidad_3 + "%";
    },
    selecciona(mision) {
      router.push("/mision-" + mision + "-intro");
    },
    avanzar() {
      //router.push("/mision-1-cuestionario");
      router.push("/mision-2-intro");
      //this.$router.push("/resultados/descarga");
    },
    toggleInfo() {
      this.displayInfo = !this.displayInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
$amarillo: #ffcc00;
#progreso {
  background: url(../../../assets/imgs/resultados/bg-resultados.jpg) no-repeat;
  background-size: cover;
  background-position: bottom right;
  .contentabs {
    .logo {
      bottom: 5%;
      left: 5%;
      width: 20%;
      position: absolute;
    }
    .centradoxy {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 80%;
      left: 50%;
    }
    .personaje {
      bottom: 4%;
      right: 8%;
      width: 20%;
      position: absolute;
      img{
        width:100%;
      }
      .brillo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        animation: titilar 2s infinite;
      }
      .gadget {
        position: absolute;
        top:0px;
        left:0px;
        width:0px;
        bottom:0px;
        width: 100%;
        img {
          width: 100%;
        }
        /*&.acomodador {
          top: 37%;
          width: 37.4%;
          left: 23%;
        }
        &.asimilador {
          top: 4%;
          width: 28.4%;
          left: 25%;
        }
        &.convergente {
          top: -0.5%;
          width: 33.4%;
          left: 22%;
        }
        &.divergente {
          top: 37%;
          width: 66.4%;
          left: 9%;
        }*/
      }
    }

    .pregunta {
      top: 0%;
      left: 8%;
      width: 72%;
      position: absolute;
      .pregunta_txt {
        top: 50%;
        transform: translateY(-50%);
        left: 0%;
        width: 70%;
        margin: 0 0 0 20%;
        position: absolute;
        div {
          font-size: 1.2vw;
        }
      }
    }
    .quasar {
      top: 4.3%;
      left: 13%;
      width: 7%;
      position: absolute;
      animation: float 6s ease-in-out infinite;
      z-index: 100;
    }

    .info {
      width: 70%;
      top: 25%;
      left: 3%;
      img {
        width: auto !important;
      }
    }
    .resultado_mision {
      width: 70%;
      top: 25%;
      left: 3%;
      img {
        width: auto !important;
      }
    }

    .botonera {
      width: 40%;
      top: 13%;
      left: 54%;
      .bgtitulo {
        width: 80%;
        margin: 0 10%;
        position: relative;
        .texto {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          left: 0px;
        }
      }
      .mision {
        width: 33.33%;
        position: relative;
        .planeta {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
        .planeta-lock {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
      }
    }

    .btn-avanzar {
      position: absolute;
      bottom: 2%;
      right: 5%;
      z-index: 100;
    }

    @media (min-width: 993px) {
      .personaje {
        bottom: 4%;
        right: 5%;
        width: 23%;
      }
    }
  }

  .tarjeta {
    width: 100%;

    border-radius: 15px;
    padding: 1vw 2vw;
    .grid {
      .barra {
        height: 1vw;
        width: 0%;
        -webkit-border-top-right-radius: 2vw;
        -webkit-border-bottom-right-radius: 2vw;
        -moz-border-radius-topright: 2vw;
        -moz-border-radius-bottomright: 2vw;
        border-top-right-radius: 2vw;
        border-bottom-right-radius: 2vw;
        transition: 0.5s all ease-out;
      }
    }

    .gadget {
      img {
        width: 100% !important;
      }
    }
  }

  .overlayinfo {
    position: fixed;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    .bgoverlay {
      position: fixed;
      top: 0px;
      left: 0;
      bottom: 0;
      right: 0;
    }
    .overlay {
      position: relative;
      .closeoverlay {
        z-index: 10000;
        position: absolute;
        top: -5vw;
        right: -5vw;
        cursor: pointer;
        img {
          width: 10vw;
        }
      }
    }
  }
}
</style>
